import type { Locale, SiteContent } from "./types";
import { renderNav } from "./components/nav";
import { renderHorizon } from "./components/horizon";
import { renderHero } from "./components/hero";
import { renderNews } from "./components/news";
import { renderCapabilities } from "./components/capabilities";
import { renderModels } from "./components/models";
import { renderStory } from "./components/story";
import { renderResearch } from "./components/research";
import { renderValues } from "./components/values";
import { renderAbout } from "./components/about";
import { renderMilestones } from "./components/milestones";
import { renderTeam } from "./components/team";
import { renderCareers } from "./components/careers";
import { renderNewsletter } from "./components/newsletter";
import { renderContact } from "./components/contact";
import { renderFooter } from "./components/footer";

/**
 * 纯函数：给定内容，产出完整页面 HTML 字符串。
 * 不依赖 DOM 或 CSS，因此既能在浏览器运行，也能在 Node 里被
 * 预渲染脚本（scripts/prerender.mjs）调用生成静态 HTML —— 这正是
 * “组件是纯函数，迁移到 SSG 成本很低” 的落地方式。
 *
 * 新增板块：写好组件后在下面的数组里插入即可。
 */
export function renderApp(
  content: SiteContent,
  locale: Locale,
  locales: Locale[],
): string {
  const sections: string[] = [
    `<header class="site-nav">${renderNav(content.brand, content.nav, locale, locales, content.themeToggleLabel)}${renderHorizon()}</header>`,
    renderHero(content.hero),
    renderNews(content.news),
    renderCapabilities(content.capabilities),
    renderModels(content.models),
    renderStory(content.story),
    renderResearch(content.research),
    renderValues(content.values),
    renderAbout(content.about),
    renderMilestones(content.milestones),
    renderTeam(content.team),
    renderCareers(content.careers),
    renderNewsletter(content.newsletter),
    renderContact(content.contact),
    renderFooter(content.footer),
  ];

  return `<div class="wrap">${sections.join("")}</div>${renderBackToTop()}`;
}

/** 返回顶部按钮（滚动到一定距离后显现，交互在 interactions.ts 绑定） */
function renderBackToTop(): string {
  return `<button class="to-top" aria-label="Back to top" type="button">↑</button>`;
}
